<svg #treeSvg width="100%"></svg>